import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import RoutesOverview from './RoutesOverview';
import { bindActionCreators, Dispatch } from 'redux';
import { loadRoutesOverview } from '../../redux/modules/route/routeCreators';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    isLoading: state.route.isRouteListLoading,
    routesOverview: state.route.routesOverview,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loadRoutes: bindActionCreators(loadRoutesOverview, dispatch),
  };
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(RoutesOverview);
